import { pickBy } from 'lodash'
import { segmentApi } from '@edulastic/api'
import { hasActiveSearchCriteria } from '../dataUtils'

export const LIBRARY_SEARCH_SEGMENT = {
  ZERO_RESULTS_FOUND: 'search_zero_results_found',
}

const LIBRARY_TYPE_LABELS = {
  test: 'Test Library',
  item: 'Item Library',
}

const hasFilterValue = (value) => {
  if (Array.isArray(value)) return value.length > 0
  return value !== '' && value != null
}

export const trackSearchZeroResults = ({
  filter = {},
  libraryType,
  userId,
}) => {
  if (!hasActiveSearchCriteria(filter)) return

  const { searchString } = filter
  const search_term = Array.isArray(searchString)
    ? searchString.join(' ')
    : searchString || ''

  segmentApi.genericEventTrack(LIBRARY_SEARCH_SEGMENT.ZERO_RESULTS_FOUND, {
    search_term,
    filters_applied: pickBy(filter, hasFilterValue),
    library_type: LIBRARY_TYPE_LABELS[libraryType] || libraryType,
    user_id: userId ? `${userId}` : '',
  })
}
